import { useStaticQuery } from "gatsby";
import { graphql } from "gatsby";
import React from "react";
import AdditionalServicesLayout from "../../../../components/AdditionalServicesLayout";
import Benefits from "../../../../components/Benefits/Benefits";
import Divider from "../../../../components/Divider/Divider";
import RelatedServices from "../../../../components/RelatedServices/RelatedServices";
import VideoFeaturePanel from "../../../../components/VideoFeaturePanel/VideoFeaturePanel";

const MoneyMarketFunds = ({ location }) => {
  const {
    data,
    data: {
      benefits: benefitsData,
      services: relatedServicesData,
      Articles: articlesData,
      topics,
      client_types,
      filter_types,
    },
  } = useStaticQuery(
    graphql`
      {
        data: strapiSolutionsAdditionalServicesMoneyMarket {
          topics {
            id
            type
          }
          client_types {
            id
            Type
          }
          filter_types {
            type
          }
          faqLink {
            faq_category {
              category
            }
            text
          }
          Articles {
            articlesHeading
            insights {
              id
            }
            case_studies {
              id
            }
            press_releases {
              id
            }
            events {
              id
            }
          }
          services {
            shortDesc
            Image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    webpOptions: { quality: 100 }
                    placeholder: TRACED_SVG
                  )
                }
              }
              alternativeText
            }
          }
          benefits {
            Copy
            Title
            Icon {
              localFile {
                publicURL
              }
            }
          }
          metaData {
            pageTitle
            metadescription
          }
          featurePanel {
            copy
            heading
            headerImage {
              localFile {
                publicURL
              }
            }
            video {
              video {
                localFile {
                  publicURL
                }
              }
              transcript {
                localFile {
                  id
                  publicURL
                }
              }
            }

            mainImage {
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `
  );

  return (
    <AdditionalServicesLayout
      currentPath={location.pathname}
      metaData={data.metaData}
    >
      <VideoFeaturePanel data={data.featurePanel} />
      <Benefits benefitsData={benefitsData} faqLink={data.faqLink} />
      <Divider />
      <RelatedServices
        relatedServicesData={relatedServicesData}
        articlesData={articlesData}
        tagTypes={filter_types}
        topics={topics}
        client_types={client_types}
      />
    </AdditionalServicesLayout>
  );
};

export default MoneyMarketFunds;
